{
  "title": "การแชร์ตำแหน่งของคุณช่วยให้ขั้นตอนการเช็กอินรวดเร็วขึ้น",
  "body": "ขออภัย เราไม่สามารถดำเนินการเช็กอินของคุณให้เสร็จสมบูรณ์ได้หากไม่มีสิทธิ์เข้าถึงตำแหน่งของคุณ โปรดอนุญาตการเข้าถึงตำแหน่งเพื่อดำเนินการต่อ เราใช้ตำแหน่งของคุณเพื่อการเช็กอินที่คลังสินค้าเท่านั้น และจะไม่จัดเก็บหรือแบ่งปันข้อมูลตำแหน่งของคุณกับบุคคลที่สาม",
  "shareLocation": "แชร์ตำแหน่งของฉัน"
}
